// extracted by mini-css-extract-plugin
export default {"PageLoader":"PageLoader_nsVvI","PageLoader_title":"PageLoader_title_pTkq0"};